import React, { useState, useEffect } from "react";
import flyingPaperPlaneGif from "../assets/animations/flying_paper_plane.gif";

const InstantSampleLoadingModal: React.FC = () => {
  const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);

  const loadingMessages = [
    "Assembling your content...",
    "Formatting the layout...",
    "Crafting engaging headlines...",
    "Tailoring content to your audience...",
    "Proofreading for polish...",
    "Reviewing for clarity...",
    "Adding final touches...",
    "Almost there...",
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setLoadingMessageIndex(
        (prevIndex) => (prevIndex + 1) % loadingMessages.length
      );
    }, 4000);

    // cleanup function to clear interval
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
      <div
        className="primary-input-container"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "320px",
          height: "240px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}>
          <img src={flyingPaperPlaneGif} alt="Flying paper plane" />
          <p className="instant-sample-loading-message" style={{ minHeight: "60px" }}><b>{loadingMessages[loadingMessageIndex]}</b></p>
      </div>
  );
}

export default InstantSampleLoadingModal;
